angular.module('iqxCore')
	.controller('CandidateDiaryCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $routeParams, $location, $document, $sanitize, LanguageSvc, toastSvc) {
		FormSvc.setOptions($scope, {
			fetchAPI: 'callresult/netcandidatediary',
			multiRow: true,
			autoEdit: true
		})

		var container = angular.element(document.getElementById('diaryListContainer'))
		$scope.selectedAll = false
		$scope.loadingCalendar = true
		var isBusy = false

		$scope.today = moment()

		moment.locale('en_gb', {
			week: {
				dow: 1 // Monday is the first day of the week
			}
		})

		function getDateTime(dt, tm) {
			var d1 = ApiSvc.StringToDate(dt)
			var t1 = ApiSvc.StringToTime(tm)
			d1.setHours(t1.getHours())
			d1.setMinutes(t1.getMinutes())
			return d1
		}

		function getType(row) {
			if (row.ActionType == 'confirmable_shift') { return 'info' }
			if (row.DiaryClass == 'Holiday' || row.DiaryClass == 'Unavailable') { return 'important' }
			if (row.DiaryClass == 'Available') { return 'success' }
			if (row.DiaryClass == 'Cancelled') { return 'special' }
			return 'inverse'
		}

		function getBackgroundClass(row) {
			if (row.ActionType == 'confirmable_shift') { return 'btn-info' }
			if (row.DiaryClass == 'Unavailable') { return 'btn-danger' }
			if (row.DiaryClass == 'Holiday') { return 'btn-warning' }
			if (row.DiaryClass == 'Available') { return 'btn-success' }
			if (row.DiaryClass == 'Cancelled') { return 'diaryShiftCancelled' }

			if (moment(row.DateTo, 'YYYY-MM-DD').isBefore(new Date(), "day")) {
				return 'btn-default past-event'
			}

			return 'btn-default'
		}

		function getTitle(row) {
			var rv = row.DiaryClass

			if (
				(row.DiaryClass === 'Working' && $scope.isSwitchedOn('CANDDIARYHIDEWORKING')) ||
				(row.DiaryClass === 'Provisional' && $scope.isSwitchedOn('CANDDIARYHIDEWORKING'))) {
				return row.Description
			}

			if (row.DiaryClass === 'Working') { rv = rv + ' at ' + row.Description }

			if (row.DiaryStatus == 'Provisional' && row.ActionType === null) {
				rv = $scope.params.lang.pages.diary.waitingOnClient + row.Description
			}

			if (row.DiaryStatus === 'Provisional' && row.ActionType === 'confirmable_shift') {
				rv = $scope.params.lang.pages.diary.confirmOffer + row.Description
			}
			return rv
		}

		$scope.deleteEvent = function (id) {
			angular.forEach($scope.events, function (event, ix) {
				if (event.DiaryID == id) (delete $scope.events[ix])
			})
			$scope.eventsList = $scope.events
			angular.forEach($scope.eventsList, function (event, key) {
				$scope.eventsList[key].eventMonthYear = moment(event.startsAt).format("MMMM YYYY")
			})
			// $scope.$apply()
		}

		$scope.changeDate = function (myScope, changed) {
			if (myScope.theRecord.xDateFrom > myScope.theRecord.xDateTo) {
				if (changed == 'from') {
					myScope.theRecord.xDateTo = myScope.theRecord.xDateFrom
				} else {
					myScope.theRecord.xDateFrom = myScope.theRecord.xDateTo
				}
			}
		}

		$scope.callContactNumber = function (n) {
			window.open("tel:" + n)
		}

		$scope.showMoreInfoDialog = function () {
			return $scope.fetch({
				fetchAPI: 'callresult/NetAssignmentDatasheet?pLineID=' + $scope.lineID,
				fetchTarget: 'evtDeets',
				fetchWithPersonID: true,
				multiRow: true
			})
				.then(function () {
					var choices = [{ desc: 'Close', type: 'primary', code: '' }]
					var data = { deets: $scope.evtDeets, choices: choices }
					return FormSvc.modalInfo($scope, 'diaryMoreInfo', data, 'XL')
						.then(function (choice) {

						})
						.catch(function (err) {
							// silently fail
						})
				})
		}

		$scope.eventClicked = function (evt) {
			$scope.showMoreInfo = false

			if (evt.DiaryClass == 'Working' && $scope.isSwitchedOn('ASSIGNMENTDETAILS')) {
				$scope.showMoreInfo = true
				$scope.lineID = evt.DiaryID.replace("Shift_", "")
			}

			var theChoice = ''
			var desc = evt.Description

			if (moment(evt.startsAt).format("HH:mm") != '00:00' || moment(evt.endsAt).format("HH:mm") != '00:00') {
				var times = moment(evt.startsAt).format('DD/MM/YYYY HH:mm') + ' to ' + moment(evt.endsAt).format('HH:mm')
			} else {
				var times = times = moment(evt.startsAt).format('DD/MM/YYYY')
			}

			var choices = [{ desc: LanguageSvc.lang.candidate.diaryCloseShift, type: 'primary', code: '' }]
			if (evt.ActionType == 'confirmable_shift') {
				$scope.xCaption = LanguageSvc.lang.candidate.diaryConfirmableShiftCaption
				choices = [
					{ desc: LanguageSvc.lang.candidate.diaryAcceptShift, type: "primary", code: 'F' },
					{ desc: LanguageSvc.lang.candidate.diaryDeclineShift, type: "primary", code: 'C' },
					{ desc: LanguageSvc.lang.candidate.diaryCloseShift, type: "default", code: '' }]
			} else if (evt.ActionType == 'deleteable_shift') {
				$scope.xCaption = evt.DiaryClass
				desc = ''
				choices = [
					{ desc: LanguageSvc.lang.candidate.diaryCloseShift, type: 'primary', code: '' },
					{ desc: LanguageSvc.lang.candidate.diaryDeleteShift, type: "danger", code: 'D' }
				]
			} else if (evt.ActionType == 'cancelled_shift') {
				$scope.xCaption = LanguageSvc.lang.candidate.diaryCancelledShiftCaption
			} else if (evt.DiaryStatus == 'Provisional') {
				$scope.xCaption = LanguageSvc.lang.candidate.diaryProvisionalShiftCaption
				desc = LanguageSvc.lang.candidate.diaryProvisionalShiftDescription + desc
			} else {
				$scope.xCaption = LanguageSvc.lang.candidate.diaryWorkingShiftCaption
			}

			var data = { type: evt.DiaryClass, ShiftType: evt.ShiftType, ContactName: evt.ContactName, ContactNumber: evt.ContactNumber, desc: desc, times: times, address: evt.Address, map: evt.MapQuery, position: evt.position, choices: choices }

			return FormSvc.modalInfo($scope, 'diaryInfo', data)
				.then(function (choice) {
					theChoice = choice
					if (theChoice == 'C') {   // Cancel is irreversible - allow escape
						return ApplicationSvc.queryMessage('Please Confirm', LanguageSvc.lang.candidate.diaryConfirmRejectShift)
					}  // Other cases simply return yield a fulfilled promise of undefined value which continues the chain
					if (theChoice == 'D') {   // Cancel is irreversible - allow escape
						return ApplicationSvc.queryMessage('Please Confirm', LanguageSvc.lang.candidate.diaryConfirmDeleteAvailability)
					}  // Other cases simply return yield a fulfilled promise of undefined value which continues the chain
				})
				.then(function () {
					if (theChoice) { return $scope.exec('call/NetCandidateDiaryAdd', { pState: theChoice, IDCode: evt.DiaryID.substring(6), pPersonID: ApplicationSvc.currentUser.personID }) }
				})
				.then(function () {
					switch (theChoice) {
						case 'F':
							evt.ActionType = ''
							evt.type = 'inverse'
							evt.DiaryStatus = ''
							evt.title = 'Working at ' + evt.Description
							FormSvc.alert("Success", "You have accepted the shift.", "success")
							break
						case 'C':
							$scope.deleteEvent(evt.DiaryID)
							FormSvc.alert("Success", "You have declined the shift.", "success")
							break
						case 'D':
							$scope.deleteEvent(evt.DiaryID)
							break
					}
				})
				.catch(function (err) {
					if (typeof err === 'undefined' || err == 'escape key press' || err == 'backdrop click') { // Escape Key pressed or backdrop cancel!

					} else if (err) { ApplicationSvc.showMessage('Error', err, true) }
				})
		}

		$scope.eventEdited = function (evt) {
			if (evt.ActionType == 'deleteable_shift') {
				var sItem = evt.DiaryClass
				if (sItem == 'Available') { sItem = 'Availability' }
				if (sItem == 'Unavailable') { sItem = 'Unavailability' }
				$scope.xCaption = sItem
				var data = { xDate: evt.startsAt, xTimeFrom: evt.startsAt, xTimeTo: evt.endsAt, xAllDay: evt.AllDay }
				var newData = {}
				FormSvc.modalForm($scope, 'diaryAvailEdit', data, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
					.then(function (data) {
						newData.pdatefrom = moment(data.xDate).format('DD/MM/YYYY')
						newData.pdateto = newData.pdatefrom
						newData.ptimefrom = moment(data.xTimeFrom).format('HH:mm')
						newData.ptimeto = moment(data.xTimeTo).format('HH:mm')
						newData.AllDay = data.xAllDay
						if (newData.AllDay) {
							newData.ptimefrom = ''
							newData.ptimeto = ''
						} else if (newData.ptimeto <= newData.ptimefrom) {
							newData.pdateto = moment(data.xDate).add(1, 'd').format('DD/MM/YYYY')
						}
						return $scope.exec('call/NetCandidateDiaryAdd', { IDCode: evt.DiaryID.substring(6), pdatefrom: newData.pdatefrom, ptimefrom: newData.ptimefrom, ptimeto: newData.ptimeto, pPersonID: ApplicationSvc.currentUser.personID })
					})
					.then(function () {
						evt.startsAt = extractDateTime(newData.pdatefrom, newData.ptimefrom || '00:00')
						evt.endsAt = extractDateTime(newData.pdateto, newData.ptimeto || '23:59')
						evt.AllDay = newData.AllDay
					})
					.catch(function (err) {
						if (err) { ApplicationSvc.showMessage('Error', err, true) }
					})
			}
		}

		$scope.eventDeleted = function (evt) {
			if (evt.ActionType == 'deleteable_shift') {
				var sItem = evt.DiaryClass
				if (sItem == 'Available') { sItem = 'Availability' }
				if (sItem == 'Unavailable') { sItem = 'Unavailability' }
				ApplicationSvc.queryMessage('Delete ' + sItem, 'Delete ' + sItem + ' on ' + moment(evt.startsAt).format('DD/MM/YYYY') + ' ?')
					.then(function () {
						return $scope.exec('call/NetCandidateDiaryAdd', { pState: 'D', IDCode: evt.DiaryID.substring(6), pPersonID: ApplicationSvc.currentUser.personID })
					})
					.then(function () {
						$scope.deleteEvent(evt.DiaryID)
					})
					.catch(function (err) {
						if (err) { ApplicationSvc.showMessage('Error', err, true) }
					})
			}
		}

		$scope.viewChangeClicked = function (calendarDate, calendarNextView) {
			return false   // We don't want to change view other than by one of the buttons
		}

		$scope.convertWeekViewTitle = function () {
			if ($scope.calendarTitle.indexOf("Week " !== -1)) {
				var weekNumber = $scope.calendarTitle.replace("Week ", "")
				var sections = weekNumber.split("of ")
				var formattedWeekNumber = moment().day("Monday").week(sections[0]).year(sections[1]).toDate()
				$scope.calendarTitle = "Week Starting " + moment(formattedWeekNumber).format("DD MMM")
				$scope.$apply()
			}
		}

		$scope.dateModifierClicked = function () {
			$scope.calDate = moment($scope.calendarDate).format("MMMM YYYY")
		}

		$scope.load = function () {
			return $scope.fetch()
				.then(function () {
					$scope.events = []
					angular.forEach($scope.theRecords, function (row) {
						var doNotAdd = false
						if (row.DiaryClass === 'Available' && $scope.isSwitchedOn('CANDDIARYHDEAVLWORK')) {
							angular.forEach($scope.theRecords, function (row2) {
								var rowStart = moment(getDateTime(row.DateFrom, row.TimeFrom || '00:00'))
								var row2Start = moment(getDateTime(row2.DateFrom, row2.TimeFrom || '00:00'))
								if (row2.DiaryClass !== 'Available' && rowStart.isSame(row2Start, 'day')) {
									doNotAdd = true
								}
							})
						}
						if (doNotAdd) { return }
						$scope.events.push({
							title: getTitle(row),
							type: getType(row),
							backgroundClass: getBackgroundClass(row),
							startsAt: getDateTime(row.DateFrom, row.TimeFrom || '00:00'),
							endsAt: getDateTime(row.DateTo, row.TimeTo || '23:59'),
							editable: (row.ActionType == 'deleteable_shift'),
							deletable: (row.ActionType == 'deleteable_shift'),
							DiaryID: row.DiaryID,         // Shift_tempshiftid or Employment_employmentid
							ActionType: row.ActionType,   // deleteable_shift, confirmable_shift, cancelled_shift
							DiaryClass: row.DiaryClass,   // Holiday, Available, Unavailable, Cancelled, Working
							cssClass: (row.DiaryStatus == 'Provisional' ? 'PWorking' : row.DiaryClass),     // Holiday, Available, Unavailable, Cancelled, Working
							DiaryStatus: row.DiaryStatus, // Provisional or blank
							Description: row.Description, // company.name if Working,
							position: row.positionName, 	  // vacancy.position
							ShiftType: row.ShiftType, 	// The type of shift it is
							Address: row.Address,         // company address (comma sep) if working
							MapQuery: row.MapQuery,       // for google maps
							AllDay: (row.TimeFrom ? false : true),
							ContactName: row.ContactName,
							ContactNumber: row.ContactNumber,
							startMoment: startMoment
						})
					})
					$scope.theRecords = [] // Free the memory
				})
				.then(function () {
					$scope.eventsList = angular.copy($scope.events)
					angular.forEach($scope.eventsList, function (event, key) {
						$scope.eventsList[key].eventMonthYear = moment(event.startsAt).format("MMMM YYYY")
					})
					$scope.eventMonthyearNow = moment().format("MMMM YYYY")
				})
		}

		$scope.events = []
		$scope.eventsList = []
		$scope.cellIsOpen = true
		$scope.calendarDate = new Date() // today
		$scope.calendarView = ($routeParams.view ? $routeParams.view : 'month')
		$scope.showQuickAdd = false

		$scope.diaryKey = function () {
			return FormSvc.modalInfo($scope, 'diaryKey', {}, 'md')
		}

		$scope.quickAddAvailability = function (calDate, calCell) {
			if (isBusy) {
				return toastSvc.error('Error', 'Processing add request ...', 'quickAddError')
			}
			isBusy = true
			if ($scope.showQuickAdd === true) {
				if (!$scope.availabilityTemplate) {
					isBusy = false
					return toastSvc.error('Error', 'You need to select a template to add.', 'quickAddError')
				}

				if (calCell.events.length > 0 || calCell.isPast === true) {
					var shouldExit = false
					var calcDateTime = moment(moment(calDate).format('DD/MM/YYYY') + ' ' + $scope.availabilityTemplate.EventFrom, 'DD/MM/YYYY HH:mm')
					calCell.events.forEach(event => {
						var x = moment(event.endsAt)
						var y = moment(event.startsAt)

						if (calcDateTime.isSameOrAfter(y) && calcDateTime.isSameOrBefore(x)) {
							shouldExit = true
							isBusy = false
							return toastSvc.error('Error', 'You cannot bulk add availability to this day, you would have an overlap.', 'quickAddError')
						}
					})

					if (shouldExit) { return }
				}

				var paramString = ''
				var seperator = '|'
				paramString += $scope.availabilityTemplate.Grp + seperator
				paramString += moment(calDate).format('YYYY-MM-DD') + seperator
				paramString += $scope.availabilityTemplate.EventFrom + seperator
				paramString += $scope.availabilityTemplate.EventTo + seperator
				paramString += $scope.availabilityTemplate.EventID + seperator
				paramString += seperator + seperator

				if (paramString && paramString != "") {
					return ApiSvc.exec($scope, 'call/NetCandidateDiaryAddMultipleEvents', {
						"pParamString": paramString,
						"pPersonID": ApplicationSvc.currentUser.personID
					})
						.then(function () {
							isBusy = false
						})
						.then($scope.load)
						.catch(function (e) {
							isBusy = false
						})
				}
			} else {
				isBusy = false
				return false
			}
		}

		$scope.getAvailabilityTemplates = function () {
			// get list of templates from procedure
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateShiftTemplates', fetchTarget: 'AvailabilityTemplatesTemp', multiRow: true })
				.then(function () {
					// sort though the list returned from the procedure and put them into the appropriate groups
					$scope.AvailabilityTemplates = { a: { label: "Available", templates: [] }, u: { label: "Unavailable", templates: [] }, h: { label: "Holiday", templates: [] } }
					angular.forEach($scope.AvailabilityTemplatesTemp, function (value, key) {
						if (value.Grp == "A") {
							$scope.AvailabilityTemplates.a.templates.push(value)
						} else if (value.Grp == "U") {
							$scope.AvailabilityTemplates.u.templates.push(value)
						} else if (value.Grp == "H") {
							$scope.AvailabilityTemplates.h.templates.push(value)
						}
					})
					$scope.AvailabilityTemplatesTemp = [] // clear array as no longer needed
				})
		}

		$scope.getAvailabilityTemplates()

		$scope.load()
			.then(function () {
				$scope.loadingCalendar = false
			})

		// returns start moment unless events started previous day, in which case return start of day.
		function startMoment(start, day) {
			start = moment(start)
			if (start.isSame(day, 'day')) {
				return start
			} else {
				return day.clone().startOf('day')
			}
		}
	})
